export default "__VITE_ASSET__iL4e0r1H__"